import styled from "styled-components";

const QuestionContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  height: "100%",
});

export default QuestionContainer;
